(function($){
    // Insérer le code JS ici.
    if($('section.general-banner').length > 0){ 
        $('section.general-banner figure img').parallax($('section.general-banner figure'),2,-1);
    }

	console.log(traduction.infolettreTest);
    /* inscription a l'infolettre */
	$('.infolettre, .newsletter-form').submit(function(e){
		e.preventDefault();

		var messageLog = $(this).find('.error-log');
		

		if(!validateEmail($(this).find('input[name="email"]').val())){
			messageLog.text(traduction.emailError).removeClass('success').addClass('error').show();
			
		}else{
			// update user interface
			messageLog.html(traduction.emailProcessing).removeClass('success error').show();

			var data = {
				ajax: true,
				email: $(this).find('input[name="email"]').val(),
				lang: phpData.lang,
				action: 'newsletter_subscription'
			}
			
			// Prepare query string and send AJAX request
			$.post( phpData.ajax_url, data, function(res){
				JSON.stringify(res);

				if(res.success){				
					messageLog.removeClass('error').addClass('success').html(res.message);
					
				}else{
					messageLog.removeClass('success').addClass('error').html(res.message);
				}
			}, 'json');
			
			return false;
		}
	});

	// Select all links with hashes
	$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function(event) {
	// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
			&& 
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 700, 'linear')
					
			} 
		}

	});
    
})(jQuery);